import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import './OpalAccordionCardV1.css';
import { Link } from "react-router-dom";

const OpalAccordionCardV1 = ({
    item,
    selectedCard,
    setSelectedCard,
    search,
    onSelectItem
}) => {
    const statusMapping = {
        0: ["pending"],
        1: ["success"],
        2: ["missed"],
        3: ["inprogress"],
        4: ["recovered"],
        5: ["advanced"],
        8: ["jointcall", "success"],
        9: ["jointcall", "recovered"],
        10: ["jointcall", "advanced"]
    };

    const statusIcon = {
        "pending": "/Images/material-symbols--pending-actions.svg",
        "success": "/Images/material-symbols--check.svg",
        "missed": "/Images/akar-icons--person-cross.svg",
        "inprogress": "/Images/mdi--hourglass.svg",
        "recovered": "/Images/mdi--check-decagram.svg",
        "advanced": "/Images/material-symbols--check-advanced.svg",
        "jointcall": "/Images/mdi--handshake-outline.svg"
    }

    const highlightText = (text, query) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, "gi");
        return text.split(regex).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} className="highlighted-text">{part}</span>
            ) : (
                part
            )
        );
    };

    function formatTime(timeString) {
        if (!timeString) return "";

        const [hours, minutes] = timeString.split(":").map(Number);
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(0);

        // Format: 1am, 2pm, etc.
        let formatted = date.toLocaleTimeString([], {
            hour: 'numeric',
            hour12: true,
        });

        return formatted.toLowerCase().replace(/\s/g, ''); // remove space before am/pm
    }

    useEffect(() => {
        if (selectedCard === item.ID) {
            onSelectItem(item);
        }
    }, []);

    return (
        <Link
            to={`/coverage/${item.ID}`}
            className={`card-v1 mb-2`}
            onClick={() => {
                setSelectedCard(item.ID);
                onSelectItem(item);
            }}
        >
            <div className={`custom-card mb-2 card-body ${selectedCard === item.ID ? "active-card" : ""} p-3`}>
                <Card.Title>
                    <span>{item.Customer.type === 1 ? "DR. " : ""}</span>
                    {highlightText(item.Customer.Name?.toUpperCase(), search)}
                </Card.Title>
                <Card.Subtitle>
                    {highlightText(item.Customer.AddressDetail, search)}
                </Card.Subtitle>
                <div className="d-flex justify-content-between">
                    <Card.Text>
                        {formatTime(item.Customer?.Time_Start)}
                        {item.Customer?.Time_Start && <span className="mx-1">-</span>}
                        {formatTime(item.Customer?.Time_End)}
                    </Card.Text>
                    <div className="d-flex">
                        {statusMapping[item.Status]?.map((st, i) => (
                            <TauriImage
                                key={i}
                                localImage={statusIcon[st]}
                                alt={st}
                                className="sidebar-icon ms-1"
                            />
                        ))}
                    </div>
                </div>
            </div>
        </Link>

    );
};

export default OpalAccordionCardV1;
